export const creditCardContentBox = {
    showDisplayPinNavigation: true,
    showPayUpNavigation: true,
};
